<template>
  <div class="plan_grupo-data">
    <b-form>
      <input type="hidden" v-model="itemData.id" />
      <input type="hidden" v-model="itemData.evento" />
      <input type="hidden" v-model="itemData.status" />
      <input type="hidden" v-model="itemData.created_at" />
      <input type="hidden" v-model="itemData.updated_at" />
      <b-row>
        <b-col md="12" sm="12">
          <b-form-group label="Nº do Grupo/Lote" label-for="plan_grupos-n_lote">
            <b-form-input
              id="plan_grupos-n_lote"
              type="text"
              v-model="itemData.n_lote"
              @keypress="isNumber($event)"
              maxlength="10"
              required
              placeholder="Informe o Nº do Grupo/Lote ..."
            />
          </b-form-group>
        </b-col>
        <b-col md="12" sm="12">
          <b-form-group label="Descrição" label-for="plan_grupos-descricao">
            <b-form-textarea
              rows="7"
              max-rows="7"
              id="plan_grupos-descricao"
              type="text"
              v-model="itemData.descricao"
              maxlength="1024"
              required
              placeholder="Informe a Descrição ..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="clearfix">
        <b-button
          variant="primary"
          class="float-left"
          v-if="mode === 'save'"
          @click="save"
        >
          {{ itemData.id ? "Editar" : "Salvar" }}
        </b-button>
        <b-button variant="danger" v-if="mode === 'remove'" @click="remove">
          Excluir
        </b-button>
        <b-button class="ml-2" @click="reset">Sair</b-button>
        <code v-if="itemData.hash" class="float-right">
          Grupo Licitação: {{ itemData.hash + itemData.tblName }}
        </code>
      </div>
    </b-form>
    <PlanGrupoItensGrid :item="itemData" v-if="itemData.id" class="mt-3"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { showError } from "@/global";
import { baseApiUrl } from "@/env";
import { isNumber } from "@/config/globalFacilities";
import PlanGrupoItensGrid from "../planGrupoItensAdmin/PlanGrupoItensGrid";

export default {
  name: "PlanGrupoData",
  props: ["item"], // === plan_licitacoes
  components: { PlanGrupoItensGrid },
  data: function () {
    return {
      userParams: {},
      itemData: {},
      mode: "save",
      lblCancelar: "Cancelar",
      isNumber: isNumber,
      isDate: "",
    };
  },
  methods: {
    loadData() {
      const url = `${baseApiUrl}/plan-grupos/${this.item.id}`;
      axios.get(url).then((body) => {
        if (body.data.id) this.itemData = body.data;
        else this.itemData = { id_plan_licit: this.item.id };
      });
    },
    save() {
      const method = this.itemData.id ? "put" : "post";
      const id = this.itemData.id ? `/${this.itemData.id}` : "";
      axios[method](`${baseApiUrl}/plan-grupos${id}`, this.itemData)
        .then((res) => {
          this.itemData = res.data;
          this.$toasted.global.defaultSuccess();
          this.$emit("objectInputs");
        })
        .catch((error) => {
          showError(error);
        });
    },
    reset() {
      this.$bvModal.hide("modal-form");
    },
    loadUserParams() {
      const url = `${baseApiUrl}/users/${this.user.id}`;
      axios.get(url).then((res) => {
        this.userParams = res.data;
      });
    },
  },
  watch: {},
  mounted() {
    this.loadUserParams();
    this.loadData();
    this.getListPlanLicitacoes();
  },
  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style scoped>
input[type="email"] {
  text-transform: lowercase;
}
.float-right {
  margin-top: 5px;
  padding: 1px;
  margin-left: 10px;
  margin-bottom: 15px;
}
</style>
